import React, {memo} from 'react'
import {startCase} from 'lodash'
import {Grid, Header, Menu} from 'semantic-ui-react'
import {userIsAdmin, userIsBillingOwner} from '../../util'
import {withErrorHandling, withMeData, withPropsPresent} from '../../hoc'


const _Account = (props) => {
  const {
    isAdmin,
    me,
    isBillingOwner,
    menuSelection,
    navigate,
    basePath = '/c/account',
    children
  } = props

  const navTo = (e, path) => {
    e.preventDefault()
    navigate(`${basePath}${path}`)
  }

  return (
    <>
      <Header as='h2'>{startCase(menuSelection)}</Header>
      <Grid divided='vertically'>
        <Grid.Row columns='16'>
          <Grid.Column width='16'>
            <Menu pointing>
              <Menu.Item name='account' active={menuSelection === 'account'} as='a'
                         href='' onClick={(e) => navTo(e, '')}>Account</Menu.Item>
              {
                isAdmin && (
                  <>
                    <Menu.Item name='users' active={menuSelection === 'users'} as='a'
                               href='' onClick={(e) => navTo(e, '/users')}>Users</Menu.Item>
                  </>
                )
              }
              {
                isBillingOwner && (
                  <Menu.Item name='billing' active={menuSelection === 'billing'} as='a'
                             href='' onClick={(e) => navTo(e, '/billing')}>Billing</Menu.Item>
                )
              }
              <Menu.Item name='activity' active={menuSelection === 'activity'} as='a'
                         href='' onClick={(e) => navTo(e, '/activity')}>Activity</Menu.Item>

              {
                ((isAdmin && me.activeAccount.backupsEnabled) || (me.isSuperUser && me.superUserAccount && me.superUserAccount.backupsEnabled)) && (
                  <>
                    <Menu.Item name='backups' active={menuSelection === 'backups'} as='a'
                               href='' onClick={(e) => navTo(e, '/backups')}>Backups</Menu.Item>
                  </>
                )
              }
              <Menu.Item name='archives' active={menuSelection === 'archives'} as='a'
                         href='' onClick={(e) => navTo(e, '/suggested-archives')}>Archives</Menu.Item>
            </Menu>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width='16'>
            {children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

let Account = (props) => {
  const {location, me} = props
  const isAdmin = userIsAdmin(me)
  const isBillingOwner = userIsBillingOwner(me)
  let menuSelection = 'account'
  if (location.pathname.indexOf('/users') > -1) {
    menuSelection = 'users'
  }
  if (location.pathname.indexOf('/billing') > -1) {
    menuSelection = 'billing'
  }
  if (location.pathname.indexOf('/activity') > -1) {
    menuSelection = 'activity'
  }
  if (location.pathname.indexOf('/backups') > -1) {
    menuSelection = 'backups'
  }
  if (location.pathname.indexOf('archives') > -1) {
    menuSelection = 'archives'
  }
  props = {...props, isAdmin, isBillingOwner, menuSelection}
  return (<_Account {...props}/>)
}

Account = withPropsPresent(Account, ['me'])
Account = withMeData(Account, 'Loading profile...')
Account = withErrorHandling(Account)
Account = memo(Account)

export {_Account, Account}

export default Account